import React, { useEffect } from "react";
import styles from './Styles/commission.scss';
import axios from "axios";

const Commission = (props) => {
  return (
    <div className="commission-block">
        <div className="rate-wrap">
            <p className="rate-title">Commission Rate</p>
            {props.loading ? <div className="loader">
              <span className={`${styles['loader__element']}`}></span>
              <span className={`${styles['loader__element']}`}></span>
              <span className={`${styles['loader__element']}`}></span>
              <span className={`${styles['loader__element']}`}></span>
            </div>: props.commissionRate ?  <p className="rate-value">{props.commissionRate}%</p> : <p className="rate-value">0%</p>}
            
        </div>
        <div className="payout-wrap">
            <div
            className="commission-modal-link"
            onClick={() => {
              axios.get(`/marketplace/static/php/web/b2bWebsite.php?action=commissionBreakup&productid=${props.productId}&selling_price=${props.sp}&lastbatch_consignment_no=${props.consignmentNo}`).then((data)=>{
                props.setCommissionModalData({...data.data, ...props });
                props.toggleCommissionModal(true);
              });
            }}
            >
            {"Payout Details"}
            </div>
            <p>on SP + GST</p>
        </div>
    </div>
  );
};

export default Commission;
